import React from "react";
import Card from "react-bootstrap/Card";
import { connect } from "react-redux";
import ButtonWithPopover from "components/ButtonWithPopover";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import FormSection from "components/AgentWorkspace/FormSection";
import "./FormSection.css";
import { Container } from "react-bootstrap";

const TranscriberForm = ({
  updateSection,
  sendUpdatedResponse,
  transcriptionId,
  formData,
}) => {
  // Safely get gsi and the rest of the form data without mutating the props
  const { "Global Switch Id": globalSwitchId, ...formSections } = formData;
  const gsi = globalSwitchId?.globalSwitchId?.val;

  const reference = "saveConfirmation";

  return (
    <Container fluid>
      <Row>
        <Col md={12} lg={12}>
          <Row>
            <Col>
              {gsi && (
                <Card className="form-section">
                  <Card.Title className="gsi">
                    Global Switch ID: {gsi}
                  </Card.Title>
                </Card>
              )}
              {Object.keys(formSections).map((sectionKey) => (
                <FormSection
                  key={sectionKey}
                  sectionName={sectionKey}
                  formSection={formSections[sectionKey]}
                  updateSection={updateSection}
                  allowEditing={true}
                />
              ))}
            </Col>
          </Row>
          <Row className="top-spacer">
            <Col style={{ display: "flex", justifyContent: "right" }}>
              <ButtonWithPopover
                placement="right"
                customRef={reference + "bwp"}
                buttonVariant="success"
                buttonText="Save Form"
                buttonIsBlock={false}
                buttonIsDisabled={false}
                popoverTitle="Save the current form"
                buttonId="fax-save-button-popover"
              >
                <p className="confirmation-text">
                  Do you want to <b>save</b> this fax?
                </p>
                <div className="align-content-right">
                  <Button
                    id="fax-btn-save"
                    className="left-spacer"
                    variant="success"
                    onClick={() =>
                      sendUpdatedResponse(transcriptionId, formData)
                    }
                  >
                    Save Fax
                  </Button>
                </div>
              </ButtonWithPopover>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default connect()(TranscriberForm);
